import { useState } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { translationService } from "features/editor/services/translation";
import { AccessCheck, ConfirmButton, Overlay, IconApproved } from "@components";
import { UserRoleEnum } from "features/users/types";
import { useNotification } from "@hooks/useNotifications";

export const CheckAndApproveButton = ({ fileId, refreshList }: { fileId: number; refreshList: () => void }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const { showError } = useNotification();

  return (
    <AccessCheck minAccessLevel={UserRoleEnum.Translator} showAlert={false}>
      <Overlay isVisible={isProcessing} />
      <ConfirmButton
        dialogTitle=""
        dialogText="Check all lines for errors and approve if no errors."
        onConfirm={async () => {
          setIsProcessing(true);

          try {
            await translationService.autoApproveFile(fileId);
          } catch (error) {
            console.error(error);
            showError("Failed to check project");
          }

          setIsProcessing(false);
          refreshList();
        }}
        sx={{ cursor: "pointer" }}
      >
        <Tooltip title="Check all lines for errors and approve if no errors">
          <IconButton>
            <Box sx={{ position: "relative", left: "-3px" }}>
              <IconApproved />
              <Box sx={{ position: "absolute", left: "6px", top: 0 }}>
                <IconApproved />
              </Box>
            </Box>
          </IconButton>
        </Tooltip>
      </ConfirmButton>
    </AccessCheck>
  );
};
